import { FormField } from "#components/ui/FormField.tsx";
import { NotificationMutedIcon } from "#components/ui/NotificationMutedIcon.tsx";
import type { UpdateSmartReportForm } from "#features/smart-reports/hooks/useUpdateSmartReportForm.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Flex, Switch, Text } from "@hopper-ui/components";
import { NotificationIcon } from "@hopper-ui/icons";
import { useFormContext } from "react-hook-form";

export const SmartReportUnsubscribed = () => {
    const { tShared } = useSharedTranslation();
    const { control } = useFormContext<UpdateSmartReportForm>();

    return (
        <Flex direction="column" gap="inline-md" paddingX="inset-lg" paddingBottom="inset-lg">

            <FormField
                name="isMuted"
                control={control}
                render={({ field: { value, onChange, ...field } }) => (
                    <Flex justifyContent="space-between" alignItems="center">
                        <Flex
                            alignItems="center"
                            gap="inline-md"
                        >
                            <Flex
                                backgroundColor="neutral-weak"
                                width="core_400"
                                height="core_400"
                                borderRadius="rounded-md"
                                alignItems="center"
                                justifyContent="center"
                            >
                                {value ? <NotificationMutedIcon /> : <NotificationIcon fill="neutral" />}
                            </Flex>
                            <Flex direction="column">
                                <Text fontWeight="body-md-medium">
                                    {tShared("smartReports.unsubscribeTitle")}
                                </Text>
                                <Text color="neutral-weakest" size="xs">
                                    {tShared("smartReports.unsubscribeDescription")}
                                </Text>
                            </Flex>
                        </Flex>
                        <Switch
                            {...field}
                            isSelected={value}
                            onChange={onChange}
                            size="md"
                        />
                    </Flex>
                )}
            />
        </Flex>
    );
};
